import Nullstack from 'nullstack';
export default function IconSteam({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-steam",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "4",
    r: "1"
  }), "   ", Nullstack.element("circle", {
    cx: "4",
    cy: "12",
    r: "1"
  }), "   ", Nullstack.element("circle", {
    cx: "20",
    cy: "12",
    r: "1"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "20",
    r: "1"
  }), "   ", Nullstack.element("path", {
    d: "M5.5 5.5l3 3"
  }), "   ", Nullstack.element("path", {
    d: "M15.5 15.5l3 3"
  }), "   ", Nullstack.element("path", {
    d: "M18.5 5.5l-3 3"
  }), "   ", Nullstack.element("path", {
    d: "M8.5 15.5l-3 3"
  }), " ");
}